import { useMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';

type SubmitChurnFormRequest = {
  data: Record<string, any>;
};

function submitChurnForm(data: Record<string, any>): Promise<void> {
  return post<SubmitChurnFormRequest, void>('/api/organizations/churn-forms', { data })
    .then((resp) => {
      if (resp.status >= 400) {
        throw new Error('Error while submitting churn form.');
      }

      return undefined;
    });
}

/**
 * Hook used to submit a churn form.
 */
export function useSubmitChurnForm() {
  return useMutation({
    mutationFn: submitChurnForm,
  });
}
